import ExcelJS from "exceljs";

const READ_ERROR = "Không thể đọc file sản phẩm. Vui lòng kiểm tra file mẫu và thử lại.";
const MODE_HEADER = "Hiển thị lượt bán";
const EXTRA_HEADER = "Lượt bán bổ sung";
const CODE_HEADERS = ["Mã sản phẩm", "Mã SP"];

const rawText = (cell) => {
  const value = cell.value;
  if (value === null || value === undefined || value === "") return null;
  if (typeof value === "object") {
    if (value.richText) return value.richText.map((part) => part.text).join("");
    if ("result" in value) return value.result === null || value.result === undefined ? null : String(value.result);
    if ("text" in value) return value.text;
  }
  return String(value);
};

const readBuffer = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error(READ_ERROR));
    reader.readAsArrayBuffer(file);
  });

export const readProductSoldDisplayExcel = async (file) => {
  try {
    const book = new ExcelJS.Workbook();
    await book.xlsx.load(await readBuffer(file));
    const sheet =
      book.getWorksheet("sheet1") ||
      book.worksheets.find((w) => w && w.name.toLowerCase() === "sheet1");
    if (!sheet) throw new Error(READ_ERROR);
    const column_titles = Array.from(
      { length: sheet.getRow(1).cellCount },
      (_, i) => rawText(sheet.getCell(1, i + 1)) || ""
    );
    const codeCol = column_titles.findIndex((title) => CODE_HEADERS.includes(title));
    if (codeCol < 0) throw new Error(READ_ERROR);
    const modeCol = column_titles.indexOf(MODE_HEADER);
    const extraCol = column_titles.indexOf(EXTRA_HEADER);
    const hasOldColumns = column_titles.some((title, i) => title && i !== codeCol && i !== modeCol && i !== extraCol);
    const rows = [];
    for (let row = hasOldColumns ? 4 : 2; row <= sheet.rowCount; row += 1) {
      const product_code = rawText(sheet.getCell(row, codeCol + 1));
      if (!product_code) continue;
      rows.push({
        row,
        product_code,
        display_mode_text: modeCol < 0 ? null : rawText(sheet.getCell(row, modeCol + 1)),
        extra_sold_count_text: extraCol < 0 ? null : rawText(sheet.getCell(row, extraCol + 1)),
      });
    }
    if (!rows.length) throw new Error(READ_ERROR);
    return { rows, column_titles };
  } catch (error) {
    throw new Error(READ_ERROR);
  }
};
